module.exports = __webpack_public_path__ + "img/MotorolaG30.eccbb4c9.png";